import { AuthLayout } from '@components/layout/AuthLayout'
import { Layout } from '@components/layout/Layout'
import { AuthProvider } from '@features/auth/components/AuthContext'
import { useAuthenticator } from '@features/auth/utils/useAuthenticator'
import { NotFoundRoute } from '@pages/404'
import CreatorPage from '@pages/CreatorPage'
import LoginPage from '@pages/LoginPage'
import type { QueryClient } from '@tanstack/react-query'
import { RouteComponent, useLocation, createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { Suspense } from 'react'

const Root: RouteComponent = () => {
  const { user } = useAuthenticator()
  const location = useLocation()

  if (!user) {
    return (
      <Suspense fallback={null}>
        <AuthLayout>
          <LoginPage />
        </AuthLayout>
      </Suspense>
    )
  }

  if (location.pathname === '/creator') {
    return (
      <Suspense fallback={null}>
        <AuthLayout>
          <CreatorPage />
        </AuthLayout>
      </Suspense>
    )
  }

  return (
    <Suspense fallback={null}>
      <Layout>
        <Outlet />
      </Layout>
    </Suspense>
  )
}

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient
}>()({
  component: () => (
    <AuthProvider>
      <Root />
    </AuthProvider>
  ),
  notFoundComponent() {
    return <NotFoundRoute />
  },
})
